'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'UserAlreadyLinked',
	message: 'This user already has their billing linked.',
	soft: true
});
